import React from 'react'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle'
import { Col, Row } from 'antd'
import EscalatedSubmissionsCard from './escalated-submissions/EscalatedSubmissionsCard'
import HumanReviewProgressCard from '../analytics-section/text/human-review-progress/HumanReviewProgressCard'
import DistributionBetweenPhasesCard from '../analytics-section/text/distribution-between-phases/DistributionBetweenPhasesCard'
import Phases from '../../../../../constants/model-phases'

const TaDashboard = () => {
    const assignmentName = useSelector(assignmentSelectors.name)
    useDocumentTitle(`${assignmentName || ''} Dashboard`)

    return (
        <>
            <Row gutter={16}>
                <Col span={24} className='mb-12'>
                    <EscalatedSubmissionsCard />
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12} className='mb-16'>
                    <HumanReviewProgressCard />
                </Col>
                <Col span={12} className='mb-16'>
                    <DistributionBetweenPhasesCard
                        title='Predicted vs Human-reviewed'
                        phasesToShow={[Phases.PREDICTED, Phases.HUMAN_REVIEWED]}
                    />
                </Col>
            </Row>
        </>
    )
}

export default TaDashboard